import React from 'react'

import {Box, Button, ButtonProps, CircularProgress, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

type SubmitButtonProps = ButtonProps & {
  children: React.ReactNode
  loading?: boolean
}

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    whiteSpace: 'nowrap',
  },
  buttonProgress: {
    color: `${theme.palette.text.disabled}`,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -10,
    marginLeft: -10,
  },
}))

const SubmitButton = ({
  children,
  loading,
  color,
  variant,
  size,
  ...props
}: SubmitButtonProps) => {
  const {classes} = useStyles()
  return (
    <Button
      classes={{root: classes.root}}
      size={size || 'large'}
      color={color}
      disabled={loading}
      variant={variant || 'contained'}
      {...props}
    >
      <Box
        visibility={loading ? 'hidden' : 'visible'}
        display={'inherit'}
        alignItems={'inherit'}
      >
        {children}
      </Box>
      {loading && (
        <CircularProgress size={20} className={classes.buttonProgress} />
      )}
    </Button>
  )
}

export default SubmitButton
